/**
 * SSR listing engine definition — the `/listing` surface's own engine.
 *
 * Production keeps search and listing on separate Coveo search hubs: each has
 * its own query pipeline (conditions, ranking rules, ML models), its own API
 * key, and its own analytics segmentation. So the listing surface gets its own
 * definition rather than riding the search one with a `popularity` context
 * value — the context alone would move listing traffic onto the
 * `Assetstore_Search` pipeline.
 *
 * Like `searchEngineDefinition`, this is a CLIENT-SIDE SINGLETON: it owns the
 * generated controller hooks and the StateProvider (which only read React
 * context), and nothing ever builds an engine on it. Engines come from
 * per-request/per-hydration definitions created by the shared factory, because
 * setNavigatorContextProvider/setAccessToken store per-request state on the
 * definition and build()/hydrateStaticState register an engine-retaining
 * token-manager callback that is never released.
 *
 * `defineSearchEngine` creates one React context per call, so this definition's
 * hooks are NOT interchangeable with the search definition's. Components reach
 * whichever one backs the page they are on through SearchDefinitionContext.
 */
import { CoveoSearchHub } from '@lib/coveo/coveoConstants';
import { createSearchEngineDefinition } from './engineDefinition';

export const listingEngineDefinition = createSearchEngineDefinition(
  CoveoSearchHub.LISTING
);
